import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { CustomCellRendererProps } from 'ag-grid-react';
import { EmptyCell } from '../../formatters/genericFormatters';

// Todo: This could be replaced by a valueFormatter. The cell currently doesn't have default text-overflow because the default cell is not used.
export function NumberRenderer<T>({ value }: CustomCellRendererProps<T, number | null>): string {
  const { getNumberText } = useLocaleFormatter();
  return typeof value === 'number' ? getNumberText(value) : EmptyCell;
}

export default NumberRenderer;
